var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"position-fixed"},[_c('v-sheet',{staticClass:"px-2 py-1 my-n1",attrs:{"color":"grey darken-1","dark":"","rounded":""}},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1),_c('div',{staticClass:"pt-5"})])
}
var staticRenderFns = []

export { render, staticRenderFns }